import { Button, Dropdown, Message } from "../../../../BP2Components";
import IntlMessages from "../../../../../util/IntlMessages";
import React, { useState } from "react";
import CreateGroupModal from "../TableFilter/CreateGroupModal/CreateGroupModal";
import { addGroup } from "../../../../../services/restAPI/ListsV2";
import { useDispatch, useSelector } from "react-redux";
import { useTableListContext } from "../../../../../context/TableListContext/TableListContext";
import AddToGroupModal from "./AddToGroupModal/AddToGroupModal";
import { resetSelectedRows } from "../../../../../appRedux/actions/SelectedRows";
import { useIntl } from "react-intl";

interface IMassActions {
   listId: string;
}

const MODALS = {
   ADD_TO_GROUP: "ADD_TO_GROUP",
   CREATE_GROUP: "CREATE_GROUP",
};

const MassActions = ({ listId }: IMassActions) => {
   const selectedRowIds = useSelector((state) => state.selectedRows.selectedRowIds);
   const [isOpenMassActions, setIsOpenMassActions] = useState(false);
   const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
   const [modalType, setModalType] = useState<string>("");
   const { rowList, setGroupsIsChanged } = useTableListContext();
   const intl = useIntl();
   const dispatch = useDispatch();

   const massActionsItems = [
      {
         id: "add_to_group",
         name: <IntlMessages id="group.add_to_group" />,
         onClick: () => {
            setIsModalOpen(true);
            setModalType(MODALS.ADD_TO_GROUP);
         },
      },
      {
         id: "create_group",
         name: <IntlMessages id="global.create_group" />,
         onClick: () => {
            setIsModalOpen(true);
            setModalType(MODALS.CREATE_GROUP);
         },
      },
   ];

   const handleClose = () => {
      setIsModalOpen(false);
      dispatch(resetSelectedRows());
   };

   const handleCreateGroups = async (groupData) => {
      try {
         const selectedRows = rowList.filter((row) => selectedRowIds.includes(row.ID));
         const result = await addGroup(
            listId,
            { ...groupData, profileId: null, records: selectedRows, active: false },
            false,
            false,
         );
         if (result.status === 200) {
            handleClose();
            setGroupsIsChanged(true);
         }
      } catch (err) {
         Message.error(intl.formatMessage({ id: "global.error" }));
         console.error(err);
      }
   };

   return (
      <div className="table-mass-actions">
         <Button buttonType="default" onClick={() => setIsOpenMassActions(!isOpenMassActions)}>
            <IntlMessages id="global.mass_actions" />
            {isOpenMassActions ? (
               <span className="material-symbols-outlined">keyboard_arrow_up</span>
            ) : (
               <span className="material-symbols-outlined">keyboard_arrow_down</span>
            )}
            <Dropdown
               isOpen={isOpenMassActions}
               setIsOpen={setIsOpenMassActions}
               customItemStyle={{ fontSize: "14px" }}
               items={massActionsItems}
            />
         </Button>
         {modalType === MODALS.ADD_TO_GROUP && (
            <AddToGroupModal
               isOpen={isModalOpen}
               onCancel={() => setIsModalOpen(false)}
               onClose={handleClose}
               topBarTitle={<IntlMessages id="group.add_to_group" />}
               listId={listId}
            />
         )}
         {modalType === MODALS.CREATE_GROUP && (
            <CreateGroupModal
               isOpen={isModalOpen}
               onCancel={() => setIsModalOpen(false)}
               topBarTitle={<IntlMessages id="global.create_group" />}
               listId={listId}
               totalElements={selectedRowIds.length}
               onConfirm={handleCreateGroups}
            />
         )}
      </div>
   );
};

export default MassActions;
